import { useMemo, useState } from "react";
import { generateReport } from "../../../util/reportRegister";

// Componente para configurar e gerar relatórios

export default function ReportModalContent({
	reportColumns = [],
	data = [],
	filters,
	title = "Relatório",
	headerSubtitle,
	defaultFormat = "pdf",
	totals,
	onClose,
}) {
	// estado local das colunas (visíveis/ocultas)
	const [columnsState, setColumnsState] = useState(() =>
		reportColumns.map((c) => ({
			...c,
			visible: c.visible !== false, // default true
		}))
	);

	// formato do arquivo
	const [format, setFormat] = useState(defaultFormat); // 'pdf' | 'csv'

	const visibleCount = useMemo(() => columnsState.filter((c) => c.visible).length, [columnsState]);

	function toggleColumn(key, visible) {
		setColumnsState((prev) => prev.map((c) => (c.key === key ? { ...c, visible } : c)));
	}

	function setAll(visible) {
		setColumnsState((prev) => prev.map((c) => ({ ...c, visible })));
	}

	function handleGenerate() {
		const selectedColumns = columnsState
			.filter((c) => c.visible)
			.map(({ key, label, align, format }) => ({ key, label, align, format }));

		if (!selectedColumns.length) return; // nada selecionado

		generateReport({
			data,
			columns: selectedColumns,
			format, // 'pdf' ou 'csv'
			fileName: `Relatório ${title}`,
			filters,
			headerSubtitle,
			totals,
			// se você estiver usando aquela ordem dos filtros:
			// filtersOrder: ["param","paramDate","active","dtIni","dtFim"],
		});
	}

	return (
		<div className="w-full max-w-3xl p-4">
			{/* Cabeçalho do modal */}
			<div className="flex items-center justify-between mb-4">
				<div>
					<h2 className="text-lg font-semibold">Configurar Relatório</h2>
					<p className="text-xs text-gray-500">
						Selecione quais colunas deseja incluir e o formato de saída.
					</p>
				</div>
				{onClose ? (
					<button className="text-sm px-3 py-1 rounded bg-gray-100 hover:bg-gray-200" onClick={onClose}>
						Fechar
					</button>
				) : null}
			</div>

			{/* Ações em massa */}
			<div className="flex items-center gap-2 mb-3">
				<button
					className="text-xs px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
					onClick={() => setAll(true)}
				>
					Mostrar tudo
				</button>
				<button
					className="text-xs px-3 py-1 rounded bg-gray-100 hover:bg-gray-200"
					onClick={() => setAll(false)}
				>
					Ocultar tudo
				</button>
				<span className="text-xs text-gray-500 ml-auto">{visibleCount} colunas selecionadas</span>
			</div>

			{/* Lista de colunas com radios */}
			<div className="max-h-72 overflow-auto border rounded">
				<table className="w-full text-sm">
					<thead className="sticky top-0 bg-gray-50">
						<tr className="text-left">
							<th className="px-3 py-2">Coluna</th>
							<th className="px-3 py-2 text-center">Mostrar</th>
							<th className="px-3 py-2 text-center">Ocultar</th>
						</tr>
					</thead>
					<tbody>
						{columnsState.map((col) => (
							<tr key={col.key} className="border-t">
								<td className="px-3 py-2">
									<div className="font-medium">{col.label}</div>
								</td>
								<td className="px-3 py-2 text-center">
									<label className="inline-flex items-center gap-2 cursor-pointer">
										<input
											type="radio"
											name={`vis-${col.key}`}
											checked={col.visible === true}
											onChange={() => toggleColumn(col.key, true)}
										/>
										<span className="text-xs">Mostrar</span>
									</label>
								</td>
								<td className="px-3 py-2 text-center">
									<label className="inline-flex items-center gap-2 cursor-pointer">
										<input
											type="radio"
											name={`vis-${col.key}`}
											checked={col.visible === false}
											onChange={() => toggleColumn(col.key, false)}
										/>
										<span className="text-xs">Ocultar</span>
									</label>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			{/* Formato e botão gerar */}
			<div className="mt-4 flex items-center justify-between">
				<div className="flex items-center gap-6">
					<div className="text-sm font-medium">Formato:</div>
					<label className="inline-flex items-center gap-2 cursor-pointer">
						<input type="radio" name="fmt" checked={format === "pdf"} onChange={() => setFormat("pdf")} />
						<span className="text-sm">PDF</span>
					</label>
					<label className="inline-flex items-center gap-2 cursor-pointer">
						<input type="radio" name="fmt" checked={format === "csv"} onChange={() => setFormat("csv")} />
						<span className="text-sm">CSV</span>
					</label>
				</div>

				<button
					className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
					onClick={handleGenerate}
					disabled={!visibleCount || data.length === 0}
					title={!visibleCount ? "Selecione ao menos uma coluna" : ""}
				>
					Gerar
				</button>
			</div>
		</div>
	);
}
